// extracted by mini-css-extract-plugin
export var dropdownButton = "_45-0";
export var fullWidthDropdownButton = "_45-1";
export var icon = "_45-3";
export var iconPlaceholder = "_45-2";
export var menuItemRow = "_45-8";
export var separator = "_45-d";
export var shortcutContainer = "_45-7";
export var shortcutIconLg = "_45-6";
export var shortcutIconMd = "_45-5";
export var shortcutIconSm = "_45-4";
export var submenuChevron = "_45-c";
export var submenuDropdown = "_45-9";
export var submenuTriggerRow = "_45-a";
export var submenuTriggerRowOpen = "_45-b";